import React from "react";

// DayOption component (a single day)
const DayOption = (props) => {
    const {
        acfData,
        nthDay,
        date,
        month,
        year,
        fullDate,
        ticketDate,
        seatsAvailableGeneral,
        seatsAvailableMember,
        seatsCapacityGeneral,
        seatsCapacityMember,
        priceWAResident,
        priceNonResident,
        isMember,
        isWAResident,
        selectedDay,
        setSelectedDay,
        setAvailableTimes
    } = props;

    let months = {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December'
    }

    let days = {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday'
    }

    let soldOutMember = seatsAvailableMember == 0;
    let soldOutGeneral = seatsAvailableGeneral == 0;

    let closedMember = seatsCapacityMember == 0;
    let closedGeneral = seatsCapacityGeneral == 0;

    if (acfData && acfData.acf.closed_dates.length > 0) {
        acfData.acf.closed_dates.forEach(obj => {
            if (obj.date == fullDate) {
                closedMember = true;
                closedGeneral = true;
            }
        });
    }

    function handleClick() {
        const newSelectedDay = year + '-' + month + '-' + date;

        if(selectedDay !== newSelectedDay) {
            setAvailableTimes([]);
            setSelectedDay(newSelectedDay);
        }
    }

    return (
        <div
            className={`carousel-selector__day ${fullDate == selectedDay ? 'carousel-selector__day--selected' : ''}`}
            data-date={year + '-' + month + '-' + date}
            data-loaded={ticketDate != undefined}
            onClick={(e) => handleClick(e)}
            disabled={(isMember && (soldOutMember || closedMember)) || (!isMember && (soldOutGeneral || closedGeneral))}
        >
            <h6 className="carousel-selector__date">{days[nthDay]}<br />{months[month]} {parseInt(date)}</h6>
            {ticketDate == undefined && (!closedMember && !closedGeneral) &&
                <div className="carousel-selector__pending">
                    <i className="fa fa-spinner fa-pulse"></i>
                </div>
            }
            {/*ticketDate != undefined && !isMember && !closedGeneral &&
                <div className="carousel-selector__price">
                    {Adults from<br/>}
                    <span className="carousel-selector__price-amount">
                        ${isWAResident.isResident && isWAResident.isConfirmed ? priceWAResident + ' (WA)' : priceNonResident}
                    </span>
                </div>
            */}
            {/*((isMember && (!soldOutMember && !closedMember)) || (!isMember && (!soldOutGeneral && !closedGeneral))) && <>
                <div className="carousel-selector__ticket-meter" data-availability={isMember ? Math.ceil(((seatsAvailableMember / seatsCapacityMember) * 10) / 2) : Math.ceil(((seatsAvailableGeneral / seatsCapacityGeneral) * 10) / 2)}></div>
                <div className="carousel-selector__ticket-number">up to {isMember ? seatsAvailableMember : seatsAvailableGeneral} ticket{(isMember ? seatsAvailableMember : seatsAvailableGeneral) === 1 ? '' : 's'} available</div>
            </>*/}
            {((isMember && (soldOutMember && !closedMember)) || (!isMember && (soldOutGeneral && !closedGeneral))) &&
                <div>Sold Out</div>
            }
            {((isMember && closedMember) || (!isMember && closedGeneral)) &&
                <div>Closed</div>
            }
        </div>
    );
}

export default DayOption;